import axiosInstance from 'axios'
axiosInstance.defaults.baseURL = 'https://cetmis.tourism.gov.np/api/';
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';
/*delete axiosInstance.defaults.headers.common["Authorization"];*/
export default axiosInstance

